import styled from 'styled-components';
import { IThemeProvider, ITheme } from '../../../styles/theme';

interface IFlexibleTileDropCont {
  theme: ITheme;
  active?: boolean;
}
export const FlexibleTileDropCont = styled.div<IFlexibleTileDropCont>`
  display: flex;
  position: relative;
  width: 100%;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 400;
  ${({ theme, active }: IFlexibleTileDropCont) => `
    padding: 0 45px 0 8px;
    height: 48px;
    background: ${active ? theme.colors.primary[10] : theme.colors.neutral.primary[0]};
    color: ${theme.colors.neutral.primary[100]};

    ${!active && `&:hover { background: ${theme.colors.primary[10]};`}
  `};
`;

export const FlagImage = styled.img`
  ${({ theme }: IThemeProvider) => `
      margin: 0 ${theme.layout.spacing.mikro} 0 0;
  `}
`;

export const CheckCont = styled.div`
  position: absolute;
  right: 28px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
